var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function migrateLegacyPrintSettings(printSettings, publishedLargeProcesses) {
    if (!printSettings || printSettings.hidden_large_process_ids !== undefined) {
        return null;
    }
    var publishedIds = publishedLargeProcesses.map(function (_a) {
        var id = _a.id;
        return id;
    });
    // If no legacy whitelist is present, show all by default (hide none)
    if (!printSettings.large_process_ids || printSettings.large_process_ids.length === 0) {
        return __assign(__assign({}, printSettings), { hidden_large_process_ids: [] });
    }
    // Hide any newly published IDs not present in the legacy whitelist
    var hidden = publishedIds.filter(function (id) { return !printSettings.large_process_ids.includes(id); });
    return __assign(__assign({}, printSettings), { hidden_large_process_ids: hidden });
}
export function resolveHiddenLargeProcessIds(publishedLargeProcesses, printSettings) {
    var publishedIds = publishedLargeProcesses.map(function (_a) {
        var id = _a.id;
        return id;
    });
    if (printSettings.hidden_large_process_ids !== undefined) {
        return printSettings.hidden_large_process_ids.filter(function (id) { return publishedIds.includes(id); });
    }
    return [];
}
export function resolveVisibleLargeProcessIds(publishedLargeProcesses, printSettings) {
    var publishedIds = publishedLargeProcesses.map(function (_a) {
        var id = _a.id;
        return id;
    });
    if (!printSettings || !printSettings.id) {
        return publishedIds;
    }
    var hiddenIds = resolveHiddenLargeProcessIds(publishedLargeProcesses, printSettings);
    return publishedIds.filter(function (id) { return !hiddenIds.includes(id); });
}
export function buildLargeProcessPrintSettingsPayload(publishedLargeProcesses, selectedIds) {
    var publishedIds = publishedLargeProcesses.map(function (_a) {
        var id = _a.id;
        return id;
    });
    return {
        large_process_ids: selectedIds,
        hidden_large_process_ids: publishedIds.filter(function (id) { return !selectedIds.includes(id); })
    };
}
export function filterPublishedLargeProcessesByVisibility(publishedLargeProcesses, printSettings) {
    var visibleIds = resolveVisibleLargeProcessIds(publishedLargeProcesses, printSettings);
    return publishedLargeProcesses.filter(function (_a) {
        var id = _a.id;
        return visibleIds.includes(id);
    });
}
export function buildEffectivePrintSettings(printSettings, publishedSchedule, publishedLargeProcesses) {
    if (printSettings === null || printSettings === void 0 ? void 0 : printSettings.id) {
        return printSettings;
    }
    var allProcessIds = publishedLargeProcesses.map(function (_a) {
        var id = _a.id;
        return id;
    });
    return {
        id: '',
        date_range: [publishedSchedule.start_date, publishedSchedule.end_date],
        large_process_ids: allProcessIds,
        hidden_large_process_ids: [],
        is_small_process: false,
        is_company_logo: false,
        is_coloring: false,
        note: ''
    };
}
